if (!customElements.get('wishlist-count')) {
  customElements.define(
    'wishlist-count',
    class WishlistCount extends HTMLElement {
      connectedCallback() {
        this.bubble = this.querySelector('[data-wishlist-bubble]');
        this.number = this.querySelector('[data-wishlist-count]');
        this.label = this.querySelector('[data-wishlist-count-label]');
        this.update();
        this.unsubscribe = subscribe(Wishlist.EVENT, this.update.bind(this));
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      update() {
        const count = Wishlist.count();
        this.bubble.hidden = count === 0;
        if (count === 0) return;

        this.number.textContent = count < 100 ? count : '';
        const template = count === 1 ? this.dataset.countOne : this.dataset.countOther;
        this.label.textContent = (template || '').replace('[count]', count);
      }
    }
  );
}
